export const TitleConst = {
    ReviseProposal: "Revise RightShip inspection proposal",
    BtnReviseProposal: "Submit Revision",
    SubmittedReviseProposalMessage: "We will reach out to you if we have any questions or concerns regarding these changes.",
    SubmittedReviseProposalTitle: "Your updated proposal has been successfully submitted.",
    SubmittedReviseProposalThankYouMessage: "Thank you. We have received the updated proposal to service the inspection for:",
    
    InspectionReport: "Inspection Report",
    SubmitProposal: "Submit proposal to service RightShip inspection",
    SubmitInvoice: "Submit invoice for RightShip inspection",
    BtnSubmitProposal: "Submit Proposal",
    SubmittedProposalMessage: "We will notify you regarding the status of your proposal.",
    SubmittedProposalTitle: "Your proposal has been successfully submitted.",
    SubmittedProposalThankYouMessage: "Thank you. You have submitted a proposal to service the inspection for:",
    DeclineProposal: "Decline request to service RightShip inspection",
    ClosedProposal: "Request is closed",
    WithdrawInspection: "Withdraw from RightShip Inspection",
    ChangeInspectionDate: "Change RightShip Inspection Date",
    CancelInspection: "Cancel RightShip Inspection"
}